<template>
  <div class="ui-btn ui-btn-praise">
    <nf-praise
      :worksId="worksId"
      :hasPraised="hasPraised"
      @resfresPraise="handlePraise"
      @refreshLogin="handleRefreshWorkList"
      @backPraise="handleBackPraise"
    >
      <div class="praise-wrapper">
        <div class="heart-wrapper">
          <transition name="fade-toggle">
            <span class="icon icon-heart active" v-if="hasPraised" key="iconPraiseRed"></span>
            <span class="icon icon-heart" key="iconPraiseWhite" v-else></span>
          </transition>
        </div>
        <span class="praise-count">{{ praiseNum }}</span>
      </div>
    </nf-praise>
  </div>
</template>

<script>
import NfPraise from "@/components/NfPraise"

export default {
  name: "uiBtnPraise",
  props: {
    worksId: {
      type: [String, Number],
      default: ""
    },
    hasPraised: {
      type: Boolean,
      default: false
    },
    praiseNum: {
      type: Number,
      default: 0
    }
  },
  methods: {
    handleClick(e) {
      this.$emit("click", e)
    },
    handlePraise() {
      this.$emit("resfresPraise")
    },
    handleBackPraise() {
      this.$emit("backPraise")
    },
    handleRefreshWorkList() {
      this.$emit("refreshLogin")
    },
    handleJumpWorksList() {
      this.$emit("jumpWorksList")
    },
    handleShareWorkDetail() {
      this.$emit("shareWorkDetail")
    }
  },
  components: {
    NfPraise
  }
}
</script>

<style lang="scss" scoped>
.ui-btn-praise {
  width: 3rem;
  height: 0.98rem;
  background: url("../../../../assets/images/sharepage_btn_bg.png") no-repeat center;
  background-size: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  &:active {
    opacity: 0.7;
  }
  .praise-wrapper {
    background-size: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .heart-wrapper {
      margin-right: 0.08rem;
      width: 0.44rem;
      height: 0.44rem;
      position: relative;
    }
    .icon-heart {
      position: absolute;
      top: 0;
      left: 0;
      display: inline-block;
      width: 100%;
      height: 100%;
      background: url("../../../../assets/images/sharepage_icon_like_n.png") no-repeat center;
      background-size: 100%;
      &.active {
        background: url("../../../../assets/images/sharepage_icon_like_s.png") no-repeat center;
        background-size: 100%;
      }
    }
  }
}
</style>
